import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserSettingsModels, UserModels } from '@share-models';

export const SharedActions = createActionGroup({
  source: 'UserAccountSettings Shared',
  events: {
    'Reset To Initial State': emptyProps(),
    'Set Is Saving': props<{ isSaving: boolean }>(),
    'Show Message': props<{
      success?: string;
      error?: string;
      warning?: string;
      info?: string;
    }>(),
  },
});

export const UserActions = createActionGroup({
  source: 'User Account',
  events: {
    'Load User Profile': emptyProps(),
    'Load User Profile Fail': props<{ message?: string }>(),
    'Load User Profile Success': props<{
      payload: UserModels.UserDocument;
    }>(),
    'Session Identity': emptyProps(),
    'Create Or Get User Profile Fail': props<{ message?: string }>(),
    'Start Update User Profile': props<UserModels.UpdateUserProfileRequest>(),
    'Update User Profile': props<UserModels.UpdateUserProfileRequest>(),
    'Update User Profile Success': props<{
      payload: UserModels.UserDocument;
    }>(),
    'Update User Profile Fail': props<{ message?: string }>(),
    'Start Change Email Process': props<{ email: string }>(),
    'Change Email Request': props<{ email: string }>(),
    'Change Email Request Success': props<{ id: string }>(),
    'Change Email Request Fail': props<{ error: string }>(),
    'Start Change Phone Process': props<{ phone: string }>(),
    'Change Phone Request': props<{ phone: string }>(),
    'Change Phone Request Success': props<{ id: string }>(),
    'Change Phone Request Fail': props<{ error: string }>(),
    'Renew Token': props<{ orgId?: string | null }>(),
    'Set Timezone': props<{ timezone: string }>(),
    'Set Phone': props<{ phone: string }>(),
    'Set Phone Verified': props<{ isPhoneVerified: boolean }>(),
    'Set Is Login Loading': props<{ isLoginLoading: boolean }>(),
  },
});

export const UserSettingsActions = createActionGroup({
  source: 'User Settings',
  events: {
    'Load User Settings': emptyProps(),
    'Load User Settings Fail': props<{ message?: string }>(),
    'Start Update User Settings Process': props<{
      userSettings: Partial<UserSettingsModels.UserSettingsDocument>;
    }>(),
    'Update User Settings Request': props<{
      userSettings: Partial<UserSettingsModels.UserSettingsDocument>;
    }>(),
    'Start Update Theme': props<{ theme: string }>(),
    'Update Theme Request': props<{ theme: string }>(),
    'Start Update Language': props<{ lang: string }>(),
    'Update Language Request': props<{ lang: string }>(),
    'Start Update Global Search Settings': props<{
      globalSearchSettings: UserSettingsModels.GlobalSearchSettingsModel;
    }>(),
    'Update Global Search Settings Request': props<{
      globalSearchSettings: UserSettingsModels.GlobalSearchSettingsModel;
    }>(),
    'Start Update Weekly Subscription': props<{ subForWeekly: boolean }>(),
    'Update Weekly Subscription Request': props<{ subForWeekly: boolean }>(),
    'Set User Settings': props<{
      settings: UserSettingsModels.UserSettingsDocument;
    }>(),
    'Start Confirm Code': props<{ code: number; id: string }>(),
    'Confirm Code': props<{ code: number; id: string }>(),
    'Confirm Code Success': emptyProps(),
    'Confirm Code Fail': emptyProps(),
    'Update Device Page View': props<{ newDevicePageView: boolean }>(),
    'Update Device Page View Success': props<{
      settings: UserSettingsModels.UserSettingsDocument;
    }>(),
    'Update Device Page View Fail': emptyProps(),
  },
});
